module.exports = __webpack_public_path__ + "Roboto-Light-webfont.ae03617c87fd538d00b8.svg";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Light-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.svg
// module chunks = 2